export default __webpack_public_path__ + "static/media/target.f4200c63.svg";